export default {
  computed: {
    showZeroData() {
      return this.$store.getters.getZeroData(this.chartName);
    },
    dataBarCollection() {
      if (Object.keys(this.data).length) {
        let tonalData = {
          label: this.$t('feed.analytics.tonalComment.body.title'),
          data: [
            this.getDataBySource(this.tonalItems['netural'].name),
            this.getDataBySource(this.tonalItems['positive'].name),
            this.getDataBySource(this.tonalItems['negative'].name),
          ],
          backgroundColor: [
            this.tonalItems['netural'].backgroundColor,
            this.tonalItems['positive'].backgroundColor,
            this.tonalItems['negative'].backgroundColor,
          ],
          borderColor: [
            this.tonalItems['netural'].borderColor,
            this.tonalItems['positive'].borderColor,
            this.tonalItems['negative'].borderColor,
          ],
          borderWidth: 2,
          hoverBorderWidth: 0,
          showLabel: this.showLabel,
        };

        return {
          labels: this.getLabels(),
          datasets: [tonalData],
        };
      }

      return {};
    }
  },
  methods: {
    getDataBySource(tonal) {
      return this.data.total[tonal].reduce((sum, elem) => {
        return sum + elem[1];
      }, 0);
    },
    getLabels() {
      let labels = [];
      Object.keys(this.tonalItems).forEach(item => {
        labels.push(
          this.tonalItems[item].title
        );
      });
      return labels
    }
  },
  data() {
    return {
      endTime: '23:59:59',
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            ticks: {
              padding: 10,
              pointStyle: "dote",
              fontSize: 10,
              fontFamily: "Roboto",
              fontStyle: "bold",
              fontColor: "rgb(179,188,204)",
              beginAtZero: true,
              callback: function(value) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            },
            gridLines: {
              color: "rgb(179,188,204)",
              drawOnChartArea: false,
            }
          }],
          yAxes: [{
            barPercentage: 0.5,
            categoryPercentage: 0.3,
            ticks: {
              padding: 50,
              beginAtZero: true
            },
            gridLines: {
              color: "rgba(0, 0, 0, 0)",
            }
          }],
        },
        legend: {
          display: false,
        },
        plugins: {
          datalabels: {
            display: (ctx) => {
              return ctx.dataset.showLabel;
            },
            formatter: function(value, ctx) {
              let sum = ctx.dataset.data.reduce((sum, elem) => {
                return sum + elem;
              }, 0);

              if(((value / sum) * 100) === 0) {
                return "";
              }

              const byModule =  ((value / sum) * 100) % 1;
              const quotient = value / sum;

              if(!byModule) {

                if(isNaN(quotient)) {
                  return  "";
                }

                return `${(quotient * 100).toFixed(0)}%`;
              }

              return  `${(quotient * 100).toFixed(2)}%`;
            },
            anchor: "top",
            offset: 10,
            align: 'top',
            font: {
              size: 10,
              family: "Roboto"
            }
          },
        },
        tooltips: {
          backgroundColor: '#ffffff',
          titleFontFamily: "Roboto",
          titleFontStyle: "normal",
          titleFontColor: "#5E6D82",
          bodyFontFamily: "Roboto",
          bodyFontColor: "#5E6D82",
          borderColor: "#b3bccc",
          borderWidth: 1
        },
        hover: {mode: null},
      },
    };
  },
};
